import { ModuleUser, ModuleOrganization } from '@/store/module-const';
import { computed } from 'vue';
import { mapGetters } from 'vuex';
const ShowWarningChangeSettingDownloadInvoice = () =>
	import('@/views/connectInvoice/connectTaxaxion/ShowWarningChangeSettingDownloadInvoice');
export default {
	data() {
		return {
			popupItems: {}
		};
	},
	computed: {
		...mapGetters(ModuleUser, ['Role', 'WorkPermission', 'User']),
		...mapGetters(ModuleOrganization, ['getOrganizationWorking', 'getAllOrganizations']),
		persionMissionConnectInvoice() {
			const me = this;
			if (me.User && me.User.Role === me.$ms.enum.Role.Admin) {
				return true;
			}
			return me.$ms.commonFunc.isShowPermissionWork(
				me.$ms.enum.WorkPermissionEnum.ConnectTaxaxionInput,
				me.WorkPermission
			);
		},

		persionMissionConnectOutInvoice() {
			const me = this;
			if (me.User && me.User.Role === me.$ms.enum.Role.Admin) {
				return true;
			}
			return me.$ms.commonFunc.isShowPermissionWork(
				me.$ms.enum.WorkPermissionEnum.ConnectTaxaxionOutput,
				me.WorkPermission
			);
		},
		/**
		 * Kiểm tra NSD có quyền kết nối CQT không
		 */
		permissionConnectTaxaxionInfo() {
			const me = this;
			if (me.User && me.User.Role === me.$ms.enum.Role.Admin) {
				return true;
			}
			const isInbot = me.persionMissionConnectInvoice;
			const isOutBot = me.persionMissionConnectOutInvoice;
			return isInbot || isOutBot;
		},

		/**
		 * CCTC đang làm việc có phải HKD không
		 */
		getOrgInfo() {
			const me = this;
			const orgInfo = me.$ms.commonFunc.getOrgInfoParent(me.getOrganizationWorking, me.getAllOrganizations);
			return {
				IsBusinessHousehold: orgInfo && orgInfo.IsBusinessHousehold,
				LstData: me.getListIdentityCodeForDepartment(me.getOrganizationWorking, me.getAllOrganizations)
			};
		}
	},
	methods: {
		async showWarningConnectPermission() {
			const me = this;
			await me.showWarningChangeSettingDownloadInvoice({
				width: 440,
				classContentViewer: 'ms-mgt-16px ms-mgb-16px',
				title: me.$t('i18nCommon.NoPermissionTitle'),
				content: me.$t('i18nConnectInvoice.NoPermissionMessage'),
			});
		},

		async showWarningChangeSettingDownloadInvoice(payload) {
			const me = this;
			let instance = await me.$ms.commonFunc.getPopupInstanceAsync(
				me.popupItems,
				ShowWarningChangeSettingDownloadInvoice
			);
			// Merge payload với default để không mất width/height khi caller quên truyền
			instance.currentItem = { ...instance.defaultCurrentItem(), ...payload };
			instance.showPopup();
		},
		permissionConnectTaxaxionInfoByType(isInbot) {
			const me = this;
			if (isInbot) {
				return me.persionMissionConnectInvoice;
			}

			return me.persionMissionConnectOutInvoice;
		},

		async checkPermissionAlertDownloadAgainInvoice(dataTaxaxion, isInbot = true) {
			const me = this;
			const isCheckPermission = isInbot ? me.persionMissionConnectInvoice : me.persionMissionConnectOutInvoice;
			//TH1: Nếu đơn vị đang KHÔNG kết nối với CQT
			if (!dataTaxaxion) {
				//Admin hoặc có quyền kết nối HĐ đầu vào
				if (isCheckPermission) {
					await me.showWarningChangeSettingDownloadInvoice({
						width: 440,
						classContentViewer: 'ms-mgt-16px ms-mgb-16px',
						title: me.$t('i18nConnectInvoice.FunctionNotAvailable'),
						content: me.$t('i18nConnectInvoice').ConnectTaxAndSetupInputInvoice(isInbot),
						isCustomBtn: true,
						lstButton: [
							{
								text: me.$t('i18nCommon.Close'),
								class: 'btn-close',
								key: 'close',
								typeButton: 'secondary'
							},
							{
								text: me.$t('i18nConnectInvoice.ConnectNow'),
								typeButton: 'primary',
								class: 'btn-connect-now ms-mgl-8px',
								key: 'connect'
							}
						]
					});
				} else {
					await me.showWarningChangeSettingDownloadInvoice({
						width: 440,
						classContentViewer: 'ms-mgt-16px ms-mgb-16px',
						title: me.$t('i18nConnectInvoice.FunctionNotAvailable'),
						content: me.$t('i18nConnectInvoice').ConnectTaxAndSetupInputInvoiceWithAdmin(isInbot),
						isCustomBtn: true,
						lstButton: [
							{
								text: me.$t('i18nCommon.Close'),
								class: 'btn-close-primary',
								key: 'close'
							}
						]
					});
				}

				return false;
			}

			//TH2: Nếu đơn vị đang kết nối CQT, CÓ thiết lập tải xuống HĐ đầu ra,
			// KHÔNG thiết lập tải xuống HĐ đầu vào
			if (dataTaxaxion && (isInbot ? !dataTaxaxion.IsInbot : !dataTaxaxion.IsOutbot)) {
				if (isCheckPermission) {
					await me.showWarningChangeSettingDownloadInvoice({
						width: 440,
						classContentViewer: 'ms-mgt-16px ms-mgb-16px',
						title: me.$t('i18nConnectInvoice.FunctionNotAvailable'),
						content: me.$t('i18nConnectInvoice').SetupInputInvoice(isInbot),
						isCustomBtn: true,
						lstButton: [
							{
								text: me.$t('i18nCommon.Close'),
								class: 'btn-close',
								key: 'close',
								typeButton: 'secondary'
							},
							{
								text: me.$t('i18nCommon.SetupNow'),
								typeButton: 'primary',
								class: 'btn-setup-now ms-mgl-8px',
								key: 'setup'
							}
						]
					});
				} else {
					await me.showWarningChangeSettingDownloadInvoice({
						width: 440,
						classContentViewer: 'ms-mgt-16px ms-mgb-16px',
						title: me.$t('i18nConnectInvoice.FunctionNotAvailable'),
						content: me.$t('i18nConnectInvoice').SetupInputInvoiceWithAdmin(isInbot),
						isCustomBtn: true,
						lstButton: [
							{
								text: me.$t('i18nCommon.Close'),
								class: 'btn-close-primary',
								key: 'close'
							}
						]
					});
				}
				return false;
			}
			return true;
		},

		/**
		 * Hàm lấy ra mã số thuế, cccd ở phòng ban trong cctc
		 * @param {*} orgWorking
		 * @param {*} orgs : danh sách CCTC ở dạng dữ liệu trải phẳng
		 * @returns
		 */
		getListIdentityCodeForDepartment(orgWorking, orgs) {
			const me = this;
			//Lấy thông tin MST, CCCDan của org để thực hiện valid dữ liệu
			const getIdentities = org => {
				if (!org) return [];
				return [org.IdentificationNumber, org.TaxCode].filter(code => code && code.trim());
			};
			const orgParent = me.$ms.commonFunc.getOrgInfoParent(orgWorking, orgs);
			return getIdentities(orgParent);
		}
	}
};
